import { memo } from 'react'
import { ErrorMessage, Input, Label, Skeleton } from '../../atoms'

interface FormFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string
  label: string
  error?: string
  hint?: string
  skeleton?: boolean
}

export const FormField = memo(({ id, label, error, hint, skeleton, ...rest }: FormFieldProps) => {
  if (skeleton) {
    return (
      <div className="form-group">
        <span className="form-label">{label}</span>
        <Input skeleton />
        {hint ? <Skeleton shape="text" /> : null}
      </div>
    )
  }
  // The visible helper text (the error replaces the hint) is what the input is described by
  const hintId = `${id}-hint`
  const errorId = `${id}-error`
  const describedBy = error ? errorId : hint ? hintId : undefined
  return (
    <div className="form-group">
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        error={!!error}
        aria-describedby={describedBy}
        aria-invalid={!!error}
        {...rest}
      />
      {hint && !error && (
        <span id={hintId} className="form-hint">
          {hint}
        </span>
      )}
      <ErrorMessage id={errorId} message={error} />
    </div>
  )
})

FormField.displayName = 'FormField'
